import styled from 'styled-components';
import { KoobButton } from '@koob/ui';
import { Modal } from 'components';
import { Stack } from '@koob/margaret';
import { useNavigate, useParams } from 'react-router-dom';
import { useSnack, useError } from 'hooks';
import { useTranslation, Trans } from 'react-i18next';
import { deleteSegment, getSegment } from 'api/node/segments';
import { useAsync } from 'react-async';

const Warning = styled.div`
  color: ${({ theme }) => theme.danger};
  font-weight: bold;
`;

const ArchiveSegment = () => {
  const { segmentId } = useParams();
  const navigate = useNavigate();

  const { t } = useTranslation('experienceSegment');
  const { notify } = useSnack();
  const { sendErrorSnack } = useError();

  const { data } = useAsync({
    promiseFn: getSegment,
    segmentId,
    locale: 'en',
  });

  const handleArchive = async () => {
    try {
      await deleteSegment({ segmentId });

      navigate(-1);
      notify(t('archive.success'));
    } catch (err) {
      sendErrorSnack(err);
    }
  };

  const segmentName = data?.data?.displayName?.replace("'", '’');

  return (
    <Modal
      isOpen
      title={t('archive.title', {
        name: segmentName,
      })}
      onRequestClose={() => navigate(-1)}
      footer={
        <Stack alignX="flex-end" gutterSize={1}>
          <KoobButton onClick={handleArchive} variant="danger">
            <i className="fa-regular fa-box-archive" style={{ fontSize: 20 }} />
            {t('archive.confirm')}
          </KoobButton>
          <KoobButton onClick={() => navigate(-1)} variant="secondary">
            {t('misc:cancel')}
          </KoobButton>
        </Stack>
      }
    >
      <Stack direction="column" gutterSize={1} alignX="center">
        <Warning>{t(`archive.heading`)}</Warning>
        <div>
          <Trans
            i18nKey="experienceSegment:archive.explanation"
            name={segmentName}
          >
            <strong>{{ name: segmentName }}</strong>
          </Trans>
        </div>
      </Stack>
    </Modal>
  );
};

export default ArchiveSegment;
